// v0.6.12 (A2-222) — "Download Skatteverket file" for the Swedish return.
//
// The file is Skatteverket's eSKDUpload 6.0 upload for the e-service
// "Lämna momsdeklaration" — a file to upload and sign there, not a
// submission. The server refuses it until the calculation is frozen and
// every check passes, so the button says that up front rather than
// letting the operator find out from an error.
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadSeMomsXml } from "../../lib/api";

export const SeXmlDownload = ({ calcId, frozen, readyToFile }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const blockedReason = !frozen
    ? t("ui.se_xml.blocked_frozen")
    : !readyToFile
      ? t("ui.se_xml.blocked_checks")
      : null;

  const onClick = async () => {
    setBusy(true);
    setError(null);
    const res = await downloadSeMomsXml(calcId);
    setBusy(false);
    if (!res.ok) setError(res.error || t("ui.se_xml.failed"));
  };

  return (
    <div data-testid="se-xml-download" className="mt-3 flex flex-col gap-1">
      <div className="flex items-center gap-3">
        <button
          type="button"
          data-testid="se-xml-download-btn"
          onClick={onClick}
          disabled={!!blockedReason || busy}
          aria-describedby="se-xml-download-note"
          className="rounded-lg border border-teal-600 dark:border-teal-500 px-3 py-1.5 text-sm font-medium text-teal-700 dark:text-teal-300 hover:bg-teal-50 dark:hover:bg-teal-900/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {busy ? t("ui.se_xml.preparing") : t("ui.se_xml.button")}
        </button>
        <span id="se-xml-download-note" className="text-xs text-slate-500 dark:text-slate-400">
          {blockedReason || t("ui.se_xml.note")}
        </span>
      </div>
      {error && (
        <div role="alert" data-testid="se-xml-download-error" className="text-xs text-rose-700 dark:text-rose-300">
          {error}
        </div>
      )}
    </div>
  );
};
